import React, { FC } from 'react';

import { ErrorModal } from '../../components/ErrorModal';
import TasksList from '../../components/TasksList/TasksList';
import { ErrorProvider, useErrorContext } from '../../context/ErrorContext';
import { useAntiMoneyLaunderingAssignment } from '../../hooks/useAntiMoneyLaunderingAssignment';
import { useConsentAssignments } from '../../hooks/useConsentAssignments';
import { useFundingCertificates } from '../../hooks/useFundingCertificates';
import { useSigningOrders } from '../../hooks/useSigningOrders';

const TasksApp: FC = () => {
    const { isLoading: signingOrderLoading, data: singingOrders } = useSigningOrders();
    const { isLoading: fundingCertificatesLoading, data: fundingCertificates = [] } = useFundingCertificates();
    const { isLoading: antiMoneyLaunderingAssignmentLoading, data: antiMoneyLaunderingAssignments = [] } =
        useAntiMoneyLaunderingAssignment();
    const { isLoading: consentAssignmentsLoading, data: consentAssignments = [] } = useConsentAssignments();
    const { error, setError, setShowModal, showModal } = useErrorContext();
    return (
        <div className="signing-room">
            <TasksList
                signingOrders={singingOrders?.signeringsordre ?? []}
                currentUserFnr={singingOrders?.fnr ?? ''}
                isLoading={
                    signingOrderLoading ||
                    fundingCertificatesLoading ||
                    antiMoneyLaunderingAssignmentLoading ||
                    consentAssignmentsLoading
                }
                fundingCertificates={fundingCertificates}
                antiMoneyLaunderingAssignments={antiMoneyLaunderingAssignments}
                consentAssignments={consentAssignments}
            />
            {!!error && (
                <ErrorModal error={error} setError={setError} setShowModal={setShowModal} showModal={showModal} />
            )}
        </div>
    );
};

export default () => (
    <ErrorProvider>
        <TasksApp />
    </ErrorProvider>
);
